import _ from 'lodash';
import { normalize, schema } from 'normalizr';
import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const DIET_DIAPER_RECORDS_LIST_SUCCESS =
  api.events.dietDiaperRecordsList.actionSuccess;
const DIET_DIAPER_RECORDS_LATEST_SUCCESS =
  api.events.dietDiaperRecordsLatest.actionSuccess;
const DIET_DIAPER_RECORDS_CREATE_SUCCESS =
  api.events.dietDiaperRecordsPost.actionSuccess;
const DIET_DIAPER_RECORDS_PATCH_SUCCESS =
  api.events.dietDiaperRecordsPatch.actionSuccess;
const DIET_DIAPER_RECORDS_DELETE_SUCCESS =
  api.events.dietDiaperRecordsDelete.actionSuccess;

const dietDiaperRecordSchema = new schema.Entity('dietDiaperRecords');

const dietDiaperRecordListSchema = new schema.Array(dietDiaperRecordSchema);

const defaultState = {};

export default function(state = defaultState, action) {
  switch (action.type) {
    case DIET_DIAPER_RECORDS_LIST_SUCCESS: {
      const normalizedData = normalize(action.data, dietDiaperRecordListSchema);

      return {
        ...state,
        ...normalizedData.entities.dietDiaperRecords
      };
    }
    case DIET_DIAPER_RECORDS_LATEST_SUCCESS: {
      const normalizedData = normalize(action.data, dietDiaperRecordListSchema);

      return {
        ...state,
        ...normalizedData.entities.dietDiaperRecords
      };
    }
    case DIET_DIAPER_RECORDS_CREATE_SUCCESS: {
      return {
        ...state,
        [action.data.id]: action.data
      };
    }
    case DIET_DIAPER_RECORDS_PATCH_SUCCESS: {
      return {
        ...state,
        [action.data.id]: action.data
      };
    }
    case DIET_DIAPER_RECORDS_DELETE_SUCCESS: {
      const deletedId = action.request.pathvars.id;
      return _.omit(state, [deletedId]);
    }
    case LOGOUT_SUCCESS:
      return defaultState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dietDiaperRecords.js